import { onReady } from './util/onReady';

onReady(() => {
    const menuDialog = document.querySelector<HTMLDialogElement>('dialog#navigation-menu');

    if (!menuDialog) return;

    // Handle category expand/collapse
    const categories = menuDialog.querySelectorAll<HTMLDivElement>('.category');
    categories.forEach((category) => {
        const toggleButton = category.querySelector<HTMLButtonElement>('.bi-button');
        const itemList = category.querySelector<HTMLUListElement>('ul[data-open]');

        if (toggleButton && itemList) {
            toggleButton.addEventListener('click', () => {
                itemList.dataset.open = itemList.dataset.open === 'true' ? 'false' : 'true';
            });
        }
    });
});
